import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function AssessmentThankYou() {
  const navigate = useNavigate();
  useEffect(() => {
    window.history.replaceState(null, '', '/assessment/thank-you');
    const timer = setTimeout(() => {
      navigate('/');
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        maxWidth: 400,
        width: '90%',
        padding: '40px 28px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: 48, color: '#2ecc40', marginBottom: 18 }}>✓</div>
        <div style={{ fontWeight: 600, fontSize: '1.1rem', color: '#23326b' }}>
          Survey Successfully Submitted,<br />Thank You!
        </div>
      </div>
    </div>
  );
}

export default AssessmentThankYou;